import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-cbdd9fb6")
const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass({i:true})
}
const _hoisted_2 = {
  key: 1,
  class: "t"
}
const _hoisted_3 = {
  key: 2,
  class: "popout"
}
const _hoisted_4 = ["onClick"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Ripple = _resolveComponent("Ripple")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
    iconbutton:true,
    clickable:true,
    noSelect:true,
    icon:!_ctx.text&&!_ctx.test,
    large: _ctx.large,
    colored: _ctx.colored,
    transparent: _ctx.transparent,
    grey: _ctx.grey,
    clear: _ctx.clear,
    white: _ctx.white,
    fail: _ctx.fail
  }),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clicked && _ctx.clicked(...args)))
  }, [
    _createVNode(_component_Ripple),
    (!_ctx.hidden && _ctx.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.fail)
            ? (_openBlock(), _createBlock(_component_MovingIcon, {
                key: 0,
                name: "cross",
                type: "svg",
                ref: "cross",
                hex: _ctx.hex
              }, null, 8, ["hex"]))
            : (_openBlock(), _createBlock(_component_MovingIcon, {
                key: 1,
                name: _ctx.success?'tick':(_ctx.autoplay||_ctx.appearOnClick)&&_ctx.loop&&!_ctx.icon?'loader_spinner':_ctx.icon,
                autoplay: _ctx.autoplay||_ctx.appearOnClick,
                loop: _ctx.success?false:_ctx.loop,
                type: _ctx.type=='svg'||_ctx.fail?'svg':'lottie',
                hex: _ctx.hex,
                ref: "icon"
              }, null, 8, ["name", "autoplay", "loop", "type", "hex"]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.test || _ctx.text), 1))
      : _createCommentVNode("", true),
    (_ctx.popout && _ctx.popoutVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popout, (row) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row",
              onClick: _withModifiers(($event: any) => (_ctx.trigger(row)), ["stop"])
            }, [
              _createVNode(_component_Ripple),
              _createTextVNode(" " + _toDisplayString(row.text), 1)
            ], 8, _hoisted_4))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    (_ctx.popout && _ctx.popoutVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "cover",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
        }))
      : _createCommentVNode("", true)
  ], 2))
}